// extracted by mini-css-extract-plugin
export default {"page":"RequestsPage_page_UvIYM"};